import { Swiper, Pagination, Navigation, Lazy, Keyboard } from 'swiper/dist/js/swiper.esm.js';
Swiper.use([Pagination, Navigation, Lazy, Keyboard]);

export function init_horizontalSliders() {
    const SLIDER_ITEMS = document.querySelectorAll('.c-hor-scroll');

    // console.log(SLIDER_ITEMS[0].dataset);

    if( SLIDER_ITEMS.length ){
        for( let i=0, len = SLIDER_ITEMS.length; i < len; i++){

            new Swiper( SLIDER_ITEMS[i], {
                slidesPerView: SLIDER_ITEMS[0].dataset.slidesPerView,
                spaceBetween: SLIDER_ITEMS[0].dataset.spaceBetween,
                slidesPerGroup: SLIDER_ITEMS[0].dataset.slidesPerGroup,
                lazy: {
                    loadOnTransitionStart: true,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                breakpoints: {
                    800: {
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                    }
                },
                speed: 600,
            });
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/horizontal-slider.js